import { render, staticRenderFns } from "./ContainersMap.vue?vue&type=template&id=280008c6&"
import script from "./ContainersMap.vue?vue&type=script&lang=js&"
export * from "./ContainersMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports